<template>
  <div class="login-others">
    <span class="login-others-text">第三方登录</span>
    <span class="login-others-item qq" @click="qqLogin"></span>
    <span class="login-others-item wechat" @click="wechatLogin"></span>
  </div>
</template>

<script>
import { ENV_API_HOST } from '../libs/constants';

export default {
  name: 'login-others',
  props: {
    env: { type: String, default: '' },
    otherLoginCallback: { type: Function, default: null },
  },
  methods: {
    // QQ登录
    qqLogin() {
      const url = `${ENV_API_HOST[this.env].graph}/qq/redirect?redirect_uri=${encodeURIComponent(window.location.href)}`;
      this.redirectUri(url);
    },
    // 微信登录
    wechatLogin() {
      const url = `${ENV_API_HOST[this.env].graph}/wechat/redirect?redirect_uri=${encodeURIComponent(window.location.href)}`;
      this.redirectUri(url);
    },
    // 跳转
    redirectUri(url) {
      if (this.otherLoginCallback && typeof this.otherLoginCallback === 'function') {
        this.otherLoginCallback(url);
      } else {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';

.login-others {
  position: relative;
  display: inline-block;
  &-item {
    display: inline-block;
    width: 41px;
    height: 41px;
    margin: 0 10px;
    font-size: 41px;
    color: rgba(0,0,0,0.25);
    background-color: #F6F6F6;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 41px;
    cursor: pointer;
    &.qq {
      background-image: url('../imgs/qq@2x.png');
      background-size: 20px 20px;
    }
    &.wechat {
      background-image: url('../imgs/wechat@2x.png');
      background-size: 26px 21px;
    }
    &:hover {
      background-color: #eee;
    }
  }
  &-text {
    display: none;
    color: #999;
    font-size: 14px;
    line-height: 34px;
    margin-bottom: 10px;
  }
}
</style>
